<template>
  <div
    class="header"
    :class="route.name"
    v-show="!(appStore.isMobile && (route.path === '/beauty' || route.path === '/kennel'))"
  >
    <div class="bx-1200">
      <img class="logo" src="@/assets/images/logo.png" alt="logo" @click="clickLogo" />

      <Login />
    </div>
  </div>

  <div class="beauty-header" v-show="appStore.isMobile && (route.path === '/beauty' || route.path === '/kennel')">
    <div class="bh-close" @click="goBack" />
    <div class="bh-title">
      <div>{{ route.path === '/beauty' ? '选美大赛' : '热门犬舍' }}</div>
      <div>{{ route.path === '/beauty' ? 'beauty pageant' : 'Top Kennels' }}</div>
    </div>
    <div id="bhBtns"></div>
  </div>
</template>

<script setup lang="ts">
import Login from '@/components/Login/index.vue'
import { useRouter, useRoute } from 'vue-router'
import { useAppStore } from '@/stores/app'

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const clickLogo = () => {
  router.push('/')
}

const goBack = () => {
  if (window.history.length > 2) {
    router.back()
  } else {
    router.push('/')
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  height: 90px;
  width: 100%;
  box-shadow: 6px 6px 22px 0px #a38d781f;
  background-color: #fff;
  z-index: 2;
}

.logo {
  width: 179px;
  height: auto;
  cursor: pointer;
}

.bx-1200 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#bhBtns {
  :deep(.btns) {
    position: absolute;
    top: 33px;
    right: 32px;
    display: flex;
    align-items: center;

    .item {
      margin-left: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 22px;
      font-weight: 500;
      color: #c3a082;
      cursor: pointer;
      text-align: center;

      > span {
        line-height: 31px;
      }
    }

    .icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #b59076;
      box-sizing: border-box;
      box-shadow: 0px 0px 4px 0px #5c28184d;

      &.rank {
        background: url('@/assets/images/Beauty/rank.png') center / 28px 30px no-repeat;
      }

      &.rule {
        background: url('@/assets/images/Beauty/rule.png') center / 26px 32px no-repeat;
      }
    }
  }
}

.beauty-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  width: 100%;
  z-index: 2;
  height: 131px;
  background-color: #f8f4f1;

  .bh-close {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 32px;
    top: 52px;
    background: url('@/assets/images/H5/close.png') center / contain no-repeat;
  }

  .bh-title {
    text-align: center;
    font-size: 36px;
    height: 100%;
    padding-top: 30px;

    > div {
      line-height: 1.1;

      &:nth-of-type(2) {
        font-size: 28px;
        font-weight: 400;
      }
    }
  }
}
</style>
